import React, { useMemo } from "react";
import { checkPermissions } from '@comps/commonFunctions';

const BasePagination = (props) => {
  const pagination = props.pagination;
  const canView = checkPermissions(props.modkey, 'view');

  const totalPages = useMemo(() => {
    if (!pagination) return 0;
    const pages = Number(pagination.total_pages ?? pagination.last_page ?? 0);
    return Number.isFinite(pages) ? pages : 0;
  }, [pagination]);

  const rawTotalRecords = Number(pagination?.total ?? 0);
  const rawCurrentPage = Number(props.currentPage ?? pagination?.current_page ?? 1);
  const totalRecords = Number.isFinite(rawTotalRecords) ? rawTotalRecords : 0;
  const currentPage = Number.isFinite(rawCurrentPage) ? rawCurrentPage : 1;
  const hasRecords = totalRecords > 0;
  const rangeStart = Number(pagination?.from ?? 0);
  const rangeEnd = Number(pagination?.to ?? pagination?.count ?? 0);
  const visibleRange = hasRecords
    ? (rangeStart && rangeEnd ? `${rangeStart}-${rangeEnd}` : Number(pagination?.count ?? rangeEnd ?? 0))
    : 0;

  const pages = useMemo(() => {
    return Array.from({ length: Math.max(totalPages, 1) }, (_, index) => index + 1);
  }, [totalPages]);

  const goToPage = (page) => {
    if (!page || page < 1 || page > totalPages || page === currentPage) return;
    props.setCurrentPage(page);
  }

  if (!canView || !pagination || totalPages <= 1) return null;

  return (
    <div className="site-page-wrapper base-pagination-wrapper">
      <div className="modern-pagination-container" aria-label="Pagination">
        <div className="entries-info" aria-live="polite">
          Showing { visibleRange } of { totalRecords } entries
        </div>

        <div className="pagination-actions">
          <button
            className="pagination-nav-button"
            type="button"
            title="Previous page"
            aria-label="Previous page"
            onClick={ () => goToPage(currentPage - 1) }
            disabled={ currentPage <= 1 || !hasRecords }
          >
            <span aria-hidden="true">‹</span>
          </button>

          {
            props.numbering !== false ? (
              <label className="pagination-jump">
                <span className="pagination-jump__label">Page</span>
                <select
                  className="pagination-page-select"
                  value={ currentPage }
                  aria-label="Select page"
                  onChange={ (event) => goToPage(Number(event.target.value)) }
                  disabled={ totalPages <= 1 || !hasRecords }
                >
                  {
                    pages.map((page) => (
                      <option key={ page } value={ page }>
                        Page { page } / { totalPages || 1 }
                      </option>
                    ))
                  }
                </select>
              </label>
            ) : null
          }

          <button
            className="pagination-nav-button"
            type="button"
            title="Next page"
            aria-label="Next page"
            onClick={ () => goToPage(currentPage + 1) }
            disabled={ currentPage >= totalPages || !hasRecords }
          >
            <span aria-hidden="true">›</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BasePagination;
